import PropTypes from 'prop-types';

import { MIcon } from '../@material-extend';

const SnackbarIcon = ({ icon }) => <MIcon icon={icon} variant="white" fontSize={24} sx={{ mr: 1.5 }} filled />;

SnackbarIcon.propTypes = {
  icon: PropTypes.string.isRequired
};

export default SnackbarIcon;
